import { Alert, AlertTitle, useRoles } from "ra-friendsofbabba";
import { Collapse, Typography } from "@material-ui/core";
import React, { useMemo } from "react";

import { makeStyles } from "@material-ui/core/styles";
import { useFormState } from "react-final-form";
import { useTranslate } from "react-admin";

const useStyles = makeStyles((theme) => ({
  root: {
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(1),
  },
  message: {
    width: "100%",
  },
  messageDirty: {
    fontWeight: "bold",
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(2),
  },
  button: {
    marginTop: theme.spacing(1),
  },
}));

const PrintAlert = ({
  children,
  disabled = (props) =>
    ["draft", "integrations_requested"].indexOf(
      props?.record?.transaction?.state
    ) === -1,
  resource,
  visible = true,
  visibleFor = [],
  ...props
}) => {
  const roles = useRoles();
  const translate = useTranslate();
  const classes = useStyles();
  const { dirty } = useFormState({ subscription: { dirty: true } });
  const isDisabled = useMemo(
    () => (typeof disabled === "function" ? disabled(props) : disabled),
    [disabled, props]
  );
  const isVisible = useMemo(() => {
    const roleCodes = roles.map((role) => role.code);
    return (
      (visibleFor.length === 0 ||
        visibleFor.some((role) => roleCodes.includes(role))) &&
      (typeof visible === "function" ? visible(props) : visible)
    );
  }, [visible, visibleFor, roles, props]);

  return (
    <Collapse in={isVisible}>
      <Alert elevation={1} severity="info" className={classes.root}>
        <AlertTitle>
          {translate(`resources.${resource}.alert.print.title`)}
        </AlertTitle>
        <Typography variant="body1" className={classes.message}>
          <span
            dangerouslySetInnerHTML={{
              __html: translate(`resources.${resource}.alert.print.message`),
            }}
          />
        </Typography>
        {dirty && (
          <Typography variant="body2" className={classes.messageDirty}>
            <span
              dangerouslySetInnerHTML={{
                __html: translate(
                  `resources.${resource}.alert.print.message_dirty`
                ),
              }}
            />
          </Typography>
        )}
        {React.Children.map(children, (child) =>
          React.cloneElement(child, {
            className: classes.button,
            disabled: isDisabled || dirty,
            resource,
            ...props,
          })
        )}
      </Alert>
    </Collapse>
  );
};
export default PrintAlert;
